import { useQuery } from '@tanstack/react-query'

import {
  type IProductDetailsHistoryService,
  productDetailsHistoryService,
} from '../services/product-details-history.service'

interface IProductDetailsHistoryQuery extends IProductDetailsHistoryService {
  isOpenDetails: boolean
}

export const useProductDetailsHistoryQuery = (
  props: IProductDetailsHistoryQuery,
) => {
  const { clientId, productId, isOpenDetails } = props

  const { data } = useQuery({
    queryKey: ['product-history', productId],
    queryFn: () =>
      productDetailsHistoryService({
        clientId,
        productId,
      }),
    enabled: isOpenDetails,
  })

  return {
    data,
  }
}
